var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-box",class:{
    [_vm.type]: true,
    'form-shake-error': _vm.type == 'error',
    border: _vm.showBorder,
  }},[_c('span',[_vm._v(_vm._s(_vm.message))]),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }